import { Component } from '@angular/core'
import { FormBuilder, FormGroup } from '@angular/forms'
import { AuthApiService } from '../shared/services/auth-api.service'
import { HttpErrorResponse } from '@angular/common/http'
import { catchError, throwError } from 'rxjs'
import { ActivatedRoute, Router } from '@angular/router'
import { QUERY_PARAM_KEY_RETURN_URL } from '../shared/constants/query-params-keys'
import { ToasterService } from '../shared/services/toaster.service'
import { environment } from '../../environments/environment'

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
})
export class LoginComponent {
    readonly loginForm: FormGroup

    readonly LOGIN_FORM_EMAIL_KEY = 'email'
    readonly LOGIN_FORM_PASSWORD_KEY = 'password'

    constructor(
        private readonly formBuilder: FormBuilder,
        private readonly auth: AuthApiService,
        private readonly router: Router,
        private readonly route: ActivatedRoute,
        private readonly toaster: ToasterService
    ) {
        this.loginForm = this.formBuilder.group({
            [this.LOGIN_FORM_EMAIL_KEY]: [''],
            [this.LOGIN_FORM_PASSWORD_KEY]: [''],
        })

        document.addEventListener('keyup', (event: KeyboardEvent) => {
            if (event.key === 'Enter') {
                this.login()
            }
        })
    }

    login(): void {
        const email = this.loginForm.value[this.LOGIN_FORM_EMAIL_KEY]
        const password = this.loginForm.value[this.LOGIN_FORM_PASSWORD_KEY]
        if (!email) return
        this.auth
            .login(email, password)
            .pipe(
                catchError((err: HttpErrorResponse) => {
                    this.toaster.httpError(err, 'Error logging in.', true)
                    return throwError(() => err)
                })
            )
            .subscribe(() => {
                const target = this.route.snapshot.queryParams[QUERY_PARAM_KEY_RETURN_URL]
                if (target) {
                    this.router.navigateByUrl(
                        decodeURI(this.route.snapshot.queryParams[QUERY_PARAM_KEY_RETURN_URL])
                    )
                } else {
                    this.router.navigate(['/cases'])
                }
                this.loginForm.reset()
            })
    }

    goToSignUp(): void {
        window.open(environment.signUpUrl, '_blank')
    }
}
